module.exports = __webpack_public_path__ + "img/email-icon-grey.edc4487a.svg";